import { UntypedFormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

import { emailValidator, noWhitespaceValidator } from '@recruitee/common';

import {
  AnyDynamicCommonInputConfig,
  DynamicEmailInputConfig,
  DynamicTextInputConfig,
} from '../../../types';

export abstract class DynamicFormInput<
  Config extends AnyDynamicCommonInputConfig = AnyDynamicCommonInputConfig,
> {
  public readonly kind = <const>'DynamicFormInput';
  public type: Config['type'];
  public formError: ValidationErrors = {};

  public control: UntypedFormControl;
  constructor(public config: Config) {
    this.type = config.type;
    this.control = new UntypedFormControl(config.value, [
      ...this.validators(),
      ...this.customValidators(),
    ]);
  }

  public isHidden(): boolean {
    return !!this.config.hidden;
  }

  public isRemovable(): boolean {
    return !!this.config.removable;
  }

  protected validators(): ValidatorFn[] {
    return this.config.required ? [Validators.required] : [];
  }

  protected customValidators(): ValidatorFn[] {
    return this.config.validators ? this.config.validators : [];
  }
}

export class TextInput extends DynamicFormInput<DynamicTextInputConfig> {
  constructor(public config: DynamicTextInputConfig) {
    super(config);
    this.formError = this.config.validationPattern
      ? { pattern: this.config.validationPattern.errorMessage }
      : {};
  }

  protected validators(): ValidatorFn[] {
    const validators = [
      noWhitespaceValidator,
      ...(this.config.validationPattern
        ? [Validators.pattern(this.config.validationPattern.format)]
        : []),
    ];

    return super.validators().concat(validators);
  }
}

export class EmailInput extends DynamicFormInput<DynamicEmailInputConfig> {
  protected validators(): ValidatorFn[] {
    return super.validators().concat([emailValidator]);
  }
}
